import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Card, Col, Row } from 'antd';
import '../community-information.scss';
import configurationStore from 'common/stores/configuration/configuration.store';
import massService from 'common/services/mass/mass-service';
import { notification } from 'common/utils/notification';
import configurationService from 'common/services/configuration-service/configuration.service';
import { ISystemConfigurationRead } from 'common/services/configuration-service/configuration.service.types';
import dayjs, { Dayjs } from 'dayjs';
import { trackPromise } from 'react-promise-tracker';
import minMax from 'dayjs/plugin/minMax';

dayjs.extend(minMax);

const WelcomeEmailsConfiguration = observer(() => {
  const [disabled, setDisabled] = useState(true);
  const [date, setDate] = useState<Dayjs | null>();

  const setButtonStatus = (configuration: ISystemConfigurationRead | null) => {
    const lastSendToAll = configuration?.welcomeEmails?.lastSendToAll;
    const lastSendToUnregistered = configuration?.welcomeEmails?.lastSendToUnregistered;

    const parsed = [lastSendToAll, lastSendToUnregistered].filter(Boolean).map((v) => dayjs.utc(v));

    const maxDate = parsed.length ? dayjs.max([...parsed]) : null;

    setDate(maxDate);

    if (maxDate?.local().add(1, 'hour').isAfter(dayjs())) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  useEffect(() => {
    setButtonStatus(configurationStore.configuration);
  }, []);

  const sendToAllClicked = async () => {
    await trackPromise(massService.sendWelcomeEmails());
    notification.success({ duration: 5, message: 'Emails sent!' });
    var configuration = await configurationService.getSystemConfiguration();
    setButtonStatus(configuration);
    configurationStore.setConfiguration(configuration);
  };

  const sendToUnregisteredClicked = async () => {
    await trackPromise(massService.sendWelcomeEmailsToUnregistered());
    notification.success({ duration: 5, message: 'Emails sent!' });
    var configuration = await configurationService.getSystemConfiguration();
    setButtonStatus(configuration);
    configurationStore.setConfiguration(configuration);
  };

  return (
    <Card className="eiq-card eiq-card-border eiq-configuration welcome-emails">
      <Row className="eiq-card-header">
        <Col span={24}>
          <h1 className="h1">Welcome Emails</h1>
        </Col>
      </Row>
      <Row style={{ flexDirection: 'column' }}>
        <div>You can trigger sending EIQ-Connect welcome emails to the residents in this section.</div>
        <div style={{ color: '#AC2B20' }}>This is irreversible so, make sure that you want to send the welcome emails.</div>
        <div className="send-btn-wrapper">
          <Button type="primary" className="send-to-all-btn" onClick={sendToAllClicked} disabled={disabled}>
            Send to all residents
          </Button>
          {disabled && date && <span>Will be available at {date.local().add(1, 'hour').format('MM/DD/YYYY hh:mm A')}</span>}
        </div>
        <div>Sends a welcome email to all the residents in the community. Press only once.</div>
      </Row>
      <Row style={{ flexDirection: 'column' }}>
        <div className="send-btn-wrapper">
          <Button type="primary" className="send-to-unregistered-btn" onClick={sendToUnregisteredClicked} disabled={disabled}>
            Send to all unregistered residents
          </Button>
          {disabled && date && <span>Will be available at {date.local().add(1, 'hour').format('MM/DD/YYYY hh:mm A')}</span>}
        </div>
        <div>Sends a welcome email to all the residents who have not activated their EIQ-Connect accounts. Press only once.</div>
      </Row>
    </Card>
  );
});

export default WelcomeEmailsConfiguration;
